import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { REQUEST_TIMEOUT_DEFAULT } from '../app.constants';
import { Injectable } from '@angular/core';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {

    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                timeout(REQUEST_TIMEOUT_DEFAULT)
            );
    }
}
